export function isNullish(value: unknown): boolean {
  return value === null || value === undefined;
}

/**
 * Checks if the given value is null, undefined, or an empty string.
 */
export function isNullishOrEmptyString(value: unknown): boolean {
  return isNullish(value) || value === '';
}

/**
 * Checks if the given value is an empty object.
 */
export function isEmptyObject(value: unknown): boolean {
  return (
    typeof value === 'object' &&
    value !== null &&
    Object.keys(value).length === 0
  );
}

/**
 * Checks if the given value is an empty array.
 */
export function isEmptyArray(value: unknown): boolean {
  return Array.isArray(value) && value.length === 0;
}
